import type { UseFetchOptions } from '#app'

export const useApiFetch = <T>(request: string, opts?: UseFetchOptions<any, any, any, any, any, any>) => {
  const sharedOptions = useFetchSharedOptions()

  return useFetch<T>(request, {
    ...sharedOptions,
    ...opts,
  } as UseFetchOptions<any, any, any, any, any, any>)
}
